import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class MessageNotificationService {
    private _snackBar = inject(MatSnackBar);

    messageDuration = 5000;

    showSnackBar(snackcident: string, awaitDismiss = false) {
        this.messageDuration = 5000; //set the duration default everytime

        if (awaitDismiss === true) {
            this.messageDuration = 0; //clear duration so user must dismiss the message
        }
        this._snackBar.openFromComponent(NotificationComponent, {
            duration: this.messageDuration,
            data: {
                message: snackcident,
                duration: this.messageDuration,
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }

    showErrorMessage(title: string, snackcident: string, awaitDismiss = false, applicationError = false) {
        this.messageDuration = 5000; //set the duration default everytime
        
        if (awaitDismiss) {
            this.messageDuration = 0; //wait for the user to dismiss the message
        }
        let errorType = 'system';
        let errorClass = 'systemErrorNotification';

        if (applicationError === true) {
            errorType = 'application';
            errorClass = 'applicationErrorNotification';
        }

        this._snackBar.openFromComponent(NotificationComponent, {
            duration: this.messageDuration,
            data: {
                title: title,
                message: snackcident,
                duration: this.messageDuration,
                errorType: errorType,
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: errorClass,
        });
    }
}
